export default __webpack_public_path__ + "static/media/icon-add.6b504cb3.svg";